import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { ADMIN_ROLE_NAME, AuthBaseInterceptor, COMMON_ENTITY_CONFIG, InterceptorConfigService, NavBaseService, providePreloadAuth, registerCommonIcons, UserBaseService } from 'ui-ionic-comp';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { UserService } from './app/backend/user/user.service';
import { NavService } from './app/frontend/navs/nav.service';
import { registerIcons } from './app/icon-registration';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

let iconsInitialized = false;

if (!iconsInitialized) {
  registerCommonIcons();
  registerIcons();

  iconsInitialized = true;
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    importProvidersFrom(IonicModule.forRoot()), // Import IonicModule to avoid errors at the intercept guard.
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(),
    {
      provide: COMMON_ENTITY_CONFIG,
      useValue: {
        apiUrl: environment.api.url
      },
    },
    {
      provide: InterceptorConfigService,
      useFactory: (navService: NavService) => {
        const interceptorConfigService = new InterceptorConfigService();

        interceptorConfigService.headerEnvironmentKeyName = 'SPOT-Environment';
        interceptorConfigService.headerEnvironmentKeyValue = environment.api.headerParams['Spotery-Environment'];
        interceptorConfigService.headerSubscriptionKeyName = 'Ocp-Apim-Subscription-Key';
        interceptorConfigService.headerSubscriptionKeyValue = environment.api.headerParams['Ocp-Apim-Subscription-Key'];
        interceptorConfigService.signInRoute = navService.routes.signIn;

        return interceptorConfigService;
      },
      deps: [NavService], // Declare NavService as a dependency for the factory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthBaseInterceptor,
      multi: true, // Allows multiple interceptors in the pipeline
    },
    { // IMPORTANT TO BE DEFINED, OTHERWISE THROWS 'NG0200: Circular dependency in DI detected'
      provide: ADMIN_ROLE_NAME,
      useValue: 'User_Admins'
    },
    provideHttpClient(
      withFetch(), // Avoids error NG02813: Angular detected that a `HttpClient` request with the `keepalive`.
      withInterceptorsFromDi()), // Ensures interceptors work

    // Alias base tokens to your concrete services
    { provide: UserBaseService, useExisting: UserService },
    { provide: NavBaseService,  useExisting: NavService  },

    // Ensure auth is hydrated BEFORE first paint
    providePreloadAuth(UserService),
  ],
});
